<div class="{{localService.selectedLanguageCode}}" *ngIf="localService.languageContent && localService.languageContent.summary">
  <app-popup-header title="{{ !localService.languageContent.summary['header_'+summaryType] ? localService.languageContent.summary['header_0'] : localService.languageContent.summary['header_'+summaryType]}}"></app-popup-header>
  <div class="modal-body" [ngStyle]="{'max-height' : maxBodyHeight + 'px'}">
    <div *ngIf="item && (summaryType == 1 || summaryType == 4) && localService.languageContent.create_account">
      <div class="row" *ngIf="summaryType == 4">
        <div class="col-5 label_right wrap-div"><app-label [isWrap]="true" [Text]="localService.languageContent.summary.service_name" ></app-label></div>
        <div class="col-7"><span [ngClass]="getLanguageCodeName(item.v15,true)">{{getLanguageCodeName(item.v15,false)}}</span></div>
      </div>
      <div class="row" *ngIf="!localService.isHideDummy">
        <div class="col-5 label_right wrap-div"><app-label [isWrap]="true" [Text]="localService.languageContent.create_account.gender" ></app-label></div>
        <div class="col-7">{{item.v11 == '1' ? localService.languageContent.create_account.gender_male : (item.v11 == '2' ? localService.languageContent.create_account.gender_female : localService.languageContent.create_account.gender_transgender)}}</div>
      </div>
      <div class="row">
        <div class="col-5 label_right wrap-div"><app-label [isWrap]="true" [Text]="localService.languageContent.create_account.name" ></app-label></div>
        <div class="col-7"><span [ngClass]="localService.getLanguageCode(item.v1)">{{item.v2}}</span></div>
      </div>
      <div class="row">
        <div class="col-5 label_right wrap-div"><app-label [isWrap]="true" [Text]="localService.languageContent.create_account.placeholder_ph_num" ></app-label></div>
        <div class="col-7"><span class="en">{{item.v10}}</span></div>
      </div>
      <div class="row">
        <div class="col-5 label_right wrap-div"><app-label [isWrap]="true" [Text]="localService.languageContent.summary.email" ></app-label></div>
        <div class="col-7"><span class="en">{{item.v14}}</span></div>
      </div>
      <div class="row">
        <div class="col-5 label_right wrap-div"><app-label [isWrap]="true" [Text]="localService.languageContent.local_locations.postal_code" ></app-label></div>
        <div class="col-7"><span class="en">{{item.v9}}</span></div>
      </div>
      <div class="row" *ngIf="!localService.isHideDummy">
        <div class="col-5 label_right wrap-div"><app-label [isWrap]="true" [Text]="localService.languageContent.local_locations.constituency" ></app-label></div>
        <div class="col-7"><span [ngClass]="localService.getLanguageCode(item.v3)">{{item.v4}}</span></div>
      </div>
      <div class="row" *ngIf="!localService.isHideDummy">
        <div class="col-5 label_right wrap-div"><app-label [isWrap]="true" [Text]="localService.languageContent.local_locations.district" ></app-label></div>
        <div class="col-7"><span [ngClass]="localService.getLanguageCode(item.v5)">{{item.v6}}</span></div>
      </div>
      <div class="row" *ngIf="!localService.isHideDummy">
        <div class="col-5 label_right wrap-div"><app-label [isWrap]="true" [Text]="localService.languageContent.local_locations.state" ></app-label></div>
        <div class="col-7"><span [ngClass]="localService.getLanguageCode(item.v7)">{{item.v8}}</span></div>
      </div>
      <div class="row" *ngIf="summaryType == 4">
        <div class="col-12">
          <div style="text-align:right" *ngIf="!isLoadPayaments">
            <span class="button" (click)="onAction(1)">{{localService.languageContent.summary.show_payments}}</span>
          </div>
          <app-business-payments *ngIf="isLoadPayaments" [businessId]="id" [isViewMode]="true" [businessPaymentType]="3"></app-business-payments>
        </div>
      </div>
      <div class="row" *ngIf="summaryType == 4">
        <div class="col-12">
          <div style="text-align:right" *ngIf="!isLoadWorkingHours">
            <span class="button" (click)="onAction(2,1)">{{localService.languageContent.summary.show_working_hours}}</span>
          </div>
          <app-working-hours-range *ngIf="isLoadWorkingHours && workingHours" [workingRangeType]="1" [selectedRange]="workingHours" [isReadOnly]="true" [isOnlyTime]="true"></app-working-hours-range>
        </div>
      </div>
      <div class="row" *ngIf="summaryType == 1">
        <div class="col-12">
          <div style="text-align:right" *ngIf="!isShowProductBarCode">
            <span class="button" (click)="onAction(4)">{{localService.languageContent.summary.show_qr}}</span>
          </div>
          <app-qrcode-generator *ngIf="isShowProductBarCode" [value]="item.key" [categoryCode]="3" [isPopup]="false" [countryCode]="item.v16"></app-qrcode-generator>
        </div>
      </div>
    </div>
    <div *ngIf="item && summaryType == 2 && localService.languageContent.seller">
      <div class="row">
        <div class="col-5 label_right wrap-div"><app-label [isWrap]="true" [Text]="localService.languageContent.seller.name" ></app-label></div>
        <div class="col-7"><span [ngClass]="localService.getLanguageCode(item.v1)">{{item.v2}}</span></div>
      </div>
      <div class="row">
        <div class="col-5 label_right wrap-div"><app-label [isWrap]="true" [Text]="localService.languageContent.seller.map_contact_num" ></app-label></div>
        <div class="col-7">
          <div *ngFor="let itemSub of localService.splitString(item.v14)">
            <span class="en">{{itemSub}}</span>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-5 label_right wrap-div"><app-label [isWrap]="true" [Text]="localService.languageContent.seller.map_email" ></app-label></div>
        <div class="col-7">
          <div *ngFor="let itemSub of localService.splitString(item.v15)">
            <span class="en">{{itemSub}}</span>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-5 label_right wrap-div"><app-label [isWrap]="true" [Text]="localService.languageContent.local_locations.postal_code" ></app-label></div>
        <div class="col-7"><span class="en">{{item.v13}}</span></div>
      </div>
      <div class="row">
        <div class="col-5 label_right wrap-div"><app-label [isWrap]="true" [Text]="localService.languageContent.local_locations.constituency" ></app-label></div>
        <div class="col-7"><span [ngClass]="localService.getLanguageCode(item.v3)">{{item.v4}}</span></div>
      </div>
      <div class="row" *ngIf="!localService.isHideDummy">
        <div class="col-5 label_right wrap-div"><app-label [isWrap]="true" [Text]="localService.languageContent.local_locations.district" ></app-label></div>
        <div class="col-7"><span [ngClass]="localService.getLanguageCode(item.v5)">{{item.v6}}</span></div>
      </div>
      <div class="row" *ngIf="!localService.isHideDummy">
        <div class="col-5 label_right wrap-div"><app-label [isWrap]="true" [Text]="localService.languageContent.local_locations.state" ></app-label></div>
        <div class="col-7"><span [ngClass]="localService.getLanguageCode(item.v7)">{{item.v8}}</span></div>
      </div>
      <div class="row" *ngIf="!localService.isHideDummy">
        <div class="col-5 label_right wrap-div"><app-label [isWrap]="true" [Text]="localService.languageContent.seller.address" ></app-label></div>
        <div class="col-7"><span *ngIf="item.v9 != null" [ngClass]="localService.getLanguageCode(item.v9)">{{item.v10}}</span></div>
      </div>
      <div class="row">
        <div class="col-5 label_right wrap-div"><app-label [isWrap]="true" [Text]="localService.languageContent.seller.description" ></app-label></div>
        <div class="col-7"><span *ngIf="item.v11 != null" [ngClass]="localService.getLanguageCode(item.v11)">{{item.v12}}</span></div>
      </div>
      <div class="row">
        <div class="col-12">
          <div style="text-align:right" *ngIf="!isLoadPayaments">
            <span class="button" (click)="onAction(1)">{{localService.languageContent.summary.show_payments}}</span>
          </div>
          <app-business-payments *ngIf="isLoadPayaments" [businessId]="id" [isViewMode]="true" [businessPaymentType]="2"></app-business-payments>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div style="text-align:right" *ngIf="!isLoadWorkingHours">
            <span class="button" (click)="onAction(2,2)">{{localService.languageContent.summary.show_working_hours}}</span>
          </div>
          <app-working-hours-range *ngIf="isLoadWorkingHours && workingHours" [workingRangeType]="2" [selectedRange]="workingHours" [isReadOnly]="true" [isOnlyTime]="true"></app-working-hours-range>
        </div>
      </div>
      <div class="row" *ngIf="summaryType == 2">
        <div class="col-12">
          <div style="text-align:right" *ngIf="!isShowProductBarCode">
            <span class="button" (click)="onAction(4)">{{localService.languageContent.summary.show_qr}}</span>
          </div>
          <app-qrcode-generator *ngIf="isShowProductBarCode" [value]="item.key" [categoryCode]="4" [isPopup]="false" [countryCode]="item.v16"></app-qrcode-generator>
        </div>
      </div>
    </div>
    <div *ngIf="summaryType == 6 && localService.languageContent.guide">
      <div class="row">
        <div class="col-12">
          <div *ngIf="content != null" style="float:right;text-align:right">
            <i class="material-icons button icon_adjust" (click)="onAction(3)">zoom_out_map</i>
          </div>
          <app-html-viewer *ngIf="content != null" [content]="content" [contentLanguageId]="contentLanguageId"></app-html-viewer>
          <div *ngIf="content == null || content == ''" style="text-align:center;">
            {{localService.languageContent.guide.unavailable}}
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="item && summaryType == 3 && localService.languageContent.product_config">
      <div class="row styled_row">
        <div class="col-5 label_right wrap-div"><app-label [isWrap]="true" [Text]="localService.languageContent.product_config.summary_pin" ></app-label></div>
        <div class="col-7"><span class="en">{{item.v1}}</span></div>
      </div>
      <div class="row styled_row">
        <div class="col-5 label_right wrap-div"><app-label [isWrap]="true" [Text]="localService.languageContent.product_config.product_header" ></app-label></div>
        <div class="col-7"><span [ngClass]="localService.getLanguageCode(item.v3)">{{item.v4}}</span></div>
      </div>
      <div class="row styled_row">
        <div class="col-5 label_right wrap-div"><app-label [isWrap]="true" [Text]="localService.languageContent.product_config.about_header" ></app-label></div>
        <div class="col-7"><span [ngClass]="localService.getLanguageCode(item.v5)">{{item.v6}}</span></div>
      </div>
      <div class="row styled_row">
        <div class="col-5 label_right wrap-div"><app-label [isWrap]="true" [Text]="localService.languageContent.product_config.summary_ser_num" ></app-label></div>
        <div class="col-7"><span>{{item.v2 == '1' ? localService.languageContent.common.yes : localService.languageContent.common.no}}</span></div>
      </div>
      <div class="row styled_row" *ngIf="localService.basicParams.interactionType == 2 || localService.basicParams.interactionType == 4">
        <div class="col-5 label_right wrap-div"><app-label [isWrap]="true" [Text]="localService.languageContent.product_config.tab_product_notes" ></app-label></div>
        <div class="col-7"><span [ngClass]="localService.getLanguageCode(item.v7)">{{item.v8}}</span></div>
      </div>
      <div class="row">
        <div class="col-12">
          <div style="text-align:right" *ngIf="!isShowProductBarCode">
            <span class="button" (click)="onAction(4)">{{localService.languageContent.summary.show_qr}}</span>
          </div>
          <app-qrcode-generator *ngIf="isShowProductBarCode" [productId]="item.key" [businessId]="item.v9" [categoryCode]="2" [isPopup]="false" [countryCode]="item.v10"></app-qrcode-generator>
        </div>
      </div>
      <div class="row" *ngIf="localService.basicParams.interactionType == 2 || localService.basicParams.interactionType == 4">
        <div class="col-12">
          <div style="text-align:right" *ngIf="!isShowProductPricing">
            <span class="button" (click)="onAction(5,item.v9)">{{localService.languageContent.summary.show_pricing}}</span>
          </div>
          <app-pricing-container *ngIf="isShowProductPricing && pricingDetails" [items]="pricingDetails" [isReadOnly]="true"></app-pricing-container>
        </div>
      </div>
    </div>
  </div>
</div>
